/** @jsxImportSource @emotion/react */
"use client";

import type { Interpolation } from "@emotion/react";
import * as RadixUIDialog from "@radix-ui/react-dialog";
import type { ComponentProps } from "react";

import { spacing } from "../../../../../global/emotion";
import { IconButton } from "../../_core/IconButton/IconButton.emotion";
import { Text } from "../../_core/Text/Text.emotion";
import { CloseIcon } from "../../icons/Icon/NavigationIcons";

const baseStyle: Interpolation = {
  alignItems: "center",
  display: "flex",
  justifyContent: "space-between",
  paddingTop: spacing.xl,
};
const titleStyle: Interpolation = {
  alignItems: "center",
  display: "flex",
  justifyContent: "center",
  marginBottom: spacing.m,
  marginTop: spacing.none,
  width: spacing.full,
};

export type ModalHeaderProps = ComponentProps<typeof RadixUIDialog.Title> & {
  showClose?: boolean;
  titleCSS?: Interpolation;
  size?: "s" | "m" | "l";
  type?: "title" | "headline";
};

export const ModalHeader = ({
  className = "",
  onClick,
  children,
  showClose = false,
  titleCSS = {},
  type = "title",
  size = "m",
  ...props
}: ModalHeaderProps) => (
  <div css={baseStyle} className={className}>
    <Text asChild size={size} type={type}>
      <RadixUIDialog.Title css={[titleStyle, titleCSS]} {...props}>
        {children}
      </RadixUIDialog.Title>
    </Text>
    {showClose && (
      <IconButton
        icon={<CloseIcon />}
        onClick={() => window?.history.back()}
        variant={"neutral"}
      />
    )}
  </div>
);
